import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import 'dayjs/locale/zh-cn';
import App from './App';
import { store } from './store';
import './locales/i18n';
import './index.less';


// 为 window.__CSP_NONCE__ 添加类型声明
declare global {
  interface Window {
    __CSP_NONCE__?: string;
  }
}

// nonce 严格判断，防止传递 'undefined' 字符串
const nonce = (typeof window !== 'undefined' && typeof window.__CSP_NONCE__ === 'string' && window.__CSP_NONCE__)
  ? window.__CSP_NONCE__
  : undefined;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <Provider store={store}>
        <ConfigProvider csp={nonce ? { nonce } : undefined}>
            <App />
        </ConfigProvider>
    </Provider>
);

if (process.env.NODE_ENV === 'development') {
    if (module.hot) {
        module.hot.addStatusHandler((status) => {
            if (status === 'apply') {
                window.location.reload();
            }
        });
    }
}